import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'

const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'
const BASE_CLASS_NAME = 'mt-FormHasPriceDrop'

export default function FormHasPriceDrop({onChange, type, value, wrapper}) {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const handleChange = ({value: selectedValue}) => {
    const [currentValue] = selectedValue
    onChange(null, {
      field: FILTER_NAMES.HAS_PRICE_DROP,
      value: currentValue === CHECKED_ID,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_PRICE_DROP]
    })
  }

  return (
    <div className={BASE_CLASS_NAME}>
      <div className={`${BASE_CLASS_NAME}-filter`}>
        <FilterWrapperBasic
          filters={[
            {
              label: i18n.t('FILTERS.HAS_PRICE_DROP.LABEL'),
              name: FILTER_NAMES.HAS_PRICE_DROP,
              options: [
                {
                  id: CHECKED_ID,
                  label: i18n.t('FILTERS.HAS_PRICE_DROP.LABEL')
                }
              ],
              showLabel: true,
              type
            }
          ]}
          group={`${FILTER_NAMES.HAS_PRICE_DROP}Group`}
          onChange={handleChange}
          value={{[FILTER_NAMES.HAS_PRICE_DROP]: [value ? CHECKED_ID : UNCHECKED_ID]}}
          wrapper={wrapper}
        />
      </div>
    </div>
  )
}

FormHasPriceDrop.displayName = 'FormHasPriceDrop'
FormHasPriceDrop.propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.bool,
  wrapper: PropTypes.string
}
